import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css']
})
export class NewUserComponent implements OnInit {

  myForm: UntypedFormGroup;
  submitted = false;
  navisErrors: string = "";
  maherError: string = "";
  agentNotFound: boolean = false;
  truckerNotFound: boolean = false;
  scacNoMatch: boolean = false;
  adminExists: boolean = false;
  badAdmin: boolean = false;
  userExists: boolean = false;
  noScac: boolean = false;
  allSatisfied: boolean = false;
  phoneApp: boolean = false;

  activeConfirm: boolean = true;
  clientRequest: ClientRequest;
  myUser = {} as User;
  businessValue: string;
  adminValue: string;
  numberFound: number;
  phoneInt: number;
  totalNum: number;
  lowerFound: number;
  strangeFound: number;
  yesNoAnswer: string;
  public typeOfBusiness : {code:string, description:string}[] = [];
  public yesNo : {code:string, description:string}[] = [];
  subscription: Subscription;
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  phone: string = "";



  constructor(fb: UntypedFormBuilder,  private router: Router, private  globalEventsManager: GlobalEventsManager,private  queryService: QueryService, public myApp:AppComponent) {
    this.myForm = fb.group({
      username:  ['',  [Validators.required]],
      password:  ['' ],
      firstName:  ['',  [Validators.pattern( '^[a-zA-Z]+$'), Validators.required]],
      scac:          ['',  [Validators.pattern( '^[a-zA-Z]+$')]],
      lastName:  ['',  [Validators.pattern( '^[a-zA-Z]+$'), Validators.required]],
      id:             ['',  [Validators.required]],
    //  twic:  ['',  [Validators.pattern( '^[0-9]+$'), Validators.required]],
      sealink:  [ '', [Validators.pattern( '^[0-9]+$'), Validators.required]],
      phone:      ['',[Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/),Validators.required]],
      fax:           ['',  [Validators.pattern('^\\d{3}-\\d{3}-\\d{4}$')]],
      email:        ['',  [Validators.email, Validators.required]]
    });
  }

  get f() { return this.myForm.controls;}

  ngOnInit() {
    this.phoneInt = 0;
    this.typeOfBusiness = [];
    this.yesNo = [];
    this.fillBusinessRoles();
    this.yesNo.push({"code": 'N', "description": 'No'});
    this.yesNo.push({"code": 'Y', "description": 'Yes'});
    this.yesNoAnswer = this.yesNo[0].code;
    this.adminValue = this.yesNo[0].code;
    if (window.innerWidth <= 800){
      this.phoneApp = true;
    }
    this.listChanged();

  }



  checkRules(){
    var character='';
    var i=0;
    this.allSatisfied = false;


    this.totalNum = 0;
    this.lowerFound = 0;
    this.numberFound = 0;
    this.strangeFound = 0;

    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    while (i <= this.myForm.controls["password"].value.length){
      character = this.myForm.controls["password"].value.charAt(i);
      if (character==""){
      }else if (!isNaN(Number(character))){
        this.numberFound = this.numberFound + 1;
      }else if( character.match(format) ){
        this.strangeFound = this.strangeFound + 1;
      }else if (character == character.toLowerCase()){
        this.lowerFound = this.lowerFound + 1;
      }
      this.totalNum = this.totalNum + 1;
      i++;
    }

    if (this.numberFound>0 && this.strangeFound>0 && this.totalNum>5 && this.lowerFound >2){
      this.allSatisfied = true;
    }

  }

  listChanged(){
    this.myForm.markAsUntouched();

    if (this.businessValue=="HAULIER"){
      this.myForm.controls["scac"].setValidators([Validators.required]); // scac is required for the form validation for Truckers only
    }else{
      if (this.businessValue=='SHIPPER' || this.businessValue=='MISC'){
        this.myForm.controls['id'].clearValidators(); // id is not required for form validation for Consignees and MISCs
      }else{
        this.myForm.controls["id"].setValidators([Validators.required]);// id is required for Agents and Truckers
      }
      this.myForm.controls['id'].updateValueAndValidity();// updating id for validation or not
      this.myForm.controls['scac'].clearValidators();// everyone (not a trucker) clears out the scac validation for the form.
    }

    this.myForm.controls['scac'].updateValueAndValidity();// updating scac for validation or not


    if (this.businessValue=="MISC"){
  //    this.myForm.controls["twic"].setValidators([Validators.pattern( '^[0-9]+$'), Validators.required]);
      this.myForm.controls["sealink"].setValidators([Validators.pattern( '^[0-9]+$'), Validators.required]);
    }else{
      this.myForm.controls['sealink'].clearValidators();
//      this.myForm.controls['twic'].clearValidators();
    }

  //  this.myForm.controls['twic'].updateValueAndValidity();
    this.myForm.controls['sealink'].updateValueAndValidity();

  }

  showConfirmPassword(){
    if (this.activeConfirm){
      this.activeConfirm = false;
    }else{
      this.activeConfirm = true;
    }
  }

  createNewUser(){
    this.submitted = true;
    this.agentNotFound = false;
    this.truckerNotFound = false;
    this.scacNoMatch = false;
    this.adminExists = false;
    this.badAdmin = false;
    this.userExists = false;
    this.noScac = false;
    this.maherError = "";
    this.navisErrors = "";

    if (this.businessValue=="HAULIER" && (this.myForm.controls['scac'].value == null || this.myForm.controls['scac'].value == "") ){
      this.myForm.controls["scac"].markAsDirty();
      this.myForm.controls["scac"].markAsTouched();
    }




    if (!this.allSatisfied){
      return;
    }

    if (this.myForm.valid) {
      if ((this.businessValue!="SHIPPER" && this.businessValue!="MISC")  && this.adminValue=="N" ){
          this.badAdmin = true;
          return;
      }
      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.myUser.username = this.myForm.controls.username.value;
      this.myUser.username = this.myUser.username.trim();
      this.myUser.password = this.myForm.controls.password.value;
      this.myUser.first_name = this.myForm.controls.firstName.value;
      this.myUser.last_name = this.myForm.controls.lastName.value;
      if (this.businessValue=="MISC"){
      //  this.myUser.twic_number = this.myForm.controls.twic.value;
    //    this.myUser.twic_number = this.myUser.twic_number.padStart(10 ,"0")
        this.myUser.sealink = this.myForm.controls.sealink.value;
      }
      this.myUser.role = this.businessValue;
      this.myUser.systemAdmin = this.adminValue;
      this.myUser.maherError = null;
      this.myUser.navisErrors = [];
      this.myUser.phone_number = this.myForm.controls.phone.value;
      this.myUser.company_scac = this.myForm.controls.scac.value;
      if (this.myForm.controls.fax.value!=""){
        this.myUser.fax_number = this.myForm.controls.fax.value;
      }
      this.myUser.company_code = this.myForm.controls.id.value;
      this.myUser.email_address = this.myForm.controls.email.value;

      this.clientRequest.requestData = [];
      this.clientRequest.user = this.myUser;

      const lhsUserObs$ = this.queryService.saveNewAccount(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.myUser = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          if (this.myUser.maherError != null) {
              this.maherError = this.myUser.maherError;
          }else if (this.myUser.navisErrors!=null && this.myUser.navisErrors.length>0){
              for (var xx of this.myUser.navisErrors){
                this.navisErrors = this.navisErrors + xx.valueOf();
              }
          }else{
              this.myApp.showSuccessBanner("","the new user has been created successfully","login");
          }

        });
    }
  }






  fillBusinessRoles(){
    this.typeOfBusiness.push({"code": 'AGENT', "description": 'Agent'});
    this.typeOfBusiness.push({"code": 'SHIPPER', "description": 'Consignee'});
    this.typeOfBusiness.push({"code": 'MISC', "description": 'Driver'});
    this.typeOfBusiness.push({"code": 'HAULIER', "description": 'Trucking Company'});
    this.businessValue = this.typeOfBusiness[0].code;
  }


  returnBack(){
    this.router.navigate([""]);

  }
}
